
import Vue from "vue";
import TabBar from "./components/TabBar.vue";
import axios from "axios";
export default Vue.extend({
  components: { TabBar },
  name: "App",
  data: () => ({
    recordInfo: '陕ICP备15008649号-1',
    topTab: 0,
    isEn:false,
    mainTabBarItems: [
      { name: "首页", path: "/", key: 0 },
      { name: "实验室简介", path: "/introduction", key: 1 },
      { name: "新闻公告", path: "/article", key: 2 },
      { name: "实验室人员", path: "/staff", key: 3 },
      { name: "研究方向", path: "/group", key: 4 },
      { name: "研究成果", path: "/achievement", key: 5 },
    ],
    loggedTabBarItems: [
      { name: "文章管理", path: "/backstage/article", key: 0 },
      { name: "介绍管理", path: "/backstage/intro", key: 1 },
      { name: "人员管理", path: "/backstage/staff", key: 2 },
      { name: "成果管理", path: "/backstage/achievement", key: 3 },
      { name: "退出登录", path: "/", key: 4 },
    ],
    unloggedTabBarItems: [
      { name: "返回主页", path: "/", key: 1 },
    ],
    englishTabBarItems: [],
    tabBarItems: [] as any,
    startNum: 134278,
    backendVisits: 0,
    updateAvailable: false,
    _currentBuildTime: "" as string,
    _versionTimer: null as ReturnType<typeof setInterval> | null,
  }),
  computed: {
    visitorDisplay(): number {
      return this.startNum + this.backendVisits;
    },
    wechatQrUrl(): string {
      const base = process.env.BASE_URL || "/";
      const normalized = base.endsWith("/") ? base : `${base}/`;
      return `${normalized}img/wechat-official-qr.jpg`.replace(
        /([^:]\/)\/+/g,
        "$1"
      );
    },
  },
  created: function () {
    const hostname = window.location.hostname;
    if (hostname === 'npu-aslp.org') {
      this.recordInfo = '陕ICP备15008649号-1';
    } else if (hostname === 'nwpu-aslp.org') {
      this.recordInfo = '陕ICP备15008649号-2';
    }
  },
  mounted: function () {
    this.tabBarItems = this.mainTabBarItems;
    this.initVisitorTracking();
    this.initVersionCheck();
  },
  beforeDestroy: function () {
    if (this._versionTimer) {
      clearInterval(this._versionTimer);
      this._versionTimer = null;
    }
  },
  watch: {
    $route(to, from) {
      if (to.path.startsWith("/english")) {
        this.isEn = true;
      } else {
        this.isEn = false;
      }
      this.checkVersion();
      if (to.path.startsWith("/backstage")) {
        if (Vue.prototype.logged == false) {
          this.tabBarItems = this.unloggedTabBarItems;
          if (to.path !== "/backstage/login") {
            this.$router.push("/backstage/login");
          }
        } else {
          this.tabBarItems = this.loggedTabBarItems;
        }
      } else if (
        from.path == "/backstage/login" &&
        to.path == "/backstage/article"
      ) {
        this.tabBarItems = this.loggedTabBarItems;
        this.topTab = 0;
      } else if (to.path.startsWith("/backstage")) {
        this.tabBarItems = this.loggedTabBarItems;
      } else if (to.path.startsWith("/english")) {
        this.tabBarItems = this.englishTabBarItems;
      } else {
        this.tabBarItems = this.mainTabBarItems;
      }
      if (to.path.startsWith("/backstage/article")) {
        this.topTab = 0;
      } else if (to.path.startsWith("/introduction") || to.path.startsWith("/backstage/intro")) {
        this.topTab = 1;
      } else if (to.path.startsWith("/article") || to.path.startsWith("/backstage/staff")) {
        this.topTab = 2;
      } else if (to.path.startsWith("/staff") || to.path.startsWith("/backstage/achievement")) {
        this.topTab = 3;
      } else if (to.path.startsWith("/group")) {
        this.topTab = 4;
      } else if (to.path.startsWith("/achievement")) {
        this.topTab = 5;
      } else {
        this.topTab = 0;
      }
    },
  },
  methods: {
    initVisitorTracking() {
      const skip = window.location.pathname.startsWith("/backstage");
      if (!skip && !sessionStorage.getItem("aslp_visit_recorded")) {
        axios
          .post(Vue.prototype.apiUrl("record-visit"), {})
          .then(() => {
            sessionStorage.setItem("aslp_visit_recorded", "1");
            this.fetchStatistics();
          })
          .catch(() => {
            this.fetchStatistics();
          });
      } else {
        this.fetchStatistics();
      }
    },
    fetchStatistics() {
      axios
        .post(Vue.prototype.apiUrl("get-statistics"), {})
        .then((response) => {
          const data = response.data as {
            total?: number;
          };
          this.backendVisits =
            typeof data.total === "number" ? data.total : 0;
        })
        .catch(() => {
          this.backendVisits = 0;
        });
    },
    initVersionCheck() {
      const base = process.env.BASE_URL || "/";
      const normalized = base.endsWith("/") ? base : `${base}/`;
      const url = `${normalized}version.json`.replace(/([^:]\/)\/+/g, "$1");
      axios
        .get(url, { params: { _t: Date.now() } })
        .then((res) => {
          this._currentBuildTime = (res.data as any).buildTime || "";
        })
        .catch(() => undefined);
      this._versionTimer = setInterval(() => this.checkVersion(), 5 * 60 * 1000);
    },
    checkVersion() {
      if (!this._currentBuildTime) return;
      const base = process.env.BASE_URL || "/";
      const normalized = base.endsWith("/") ? base : `${base}/`;
      const url = `${normalized}version.json`.replace(/([^:]\/)\/+/g, "$1");
      axios
        .get(url, { params: { _t: Date.now() } })
        .then((res) => {
          const newTime = (res.data as any).buildTime || "";
          if (newTime && newTime !== this._currentBuildTime) {
            this.updateAvailable = true;
          }
        })
        .catch(() => undefined);
    },
    forceReload() {
      window.location.reload();
    },
  },
});
